import React from 'react';
import {connect} from "react-redux";
import {Modal} from 'antd-mobile';
//import config from '../../../assets/js/conf/config.js';
//import hkActions from '../../../rAction';
//import {request} from '../../../assets/js/libs/request.js';
import SubHeaderComponent from '../../../components/header/subheader';
import '../../../assets/css/common/user/my/index.css';
import {setScrollTop} from "../../../assets/js/utils/util";
import { Toast } from 'antd-mobile';
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import wx from 'weixin-js-sdk';

export default class IndexComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            sHead: localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']).photo:require("../../../assets/images/user/my/default-head.png"),
            sNickname: localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']).accName:"路人甲",
            iPoints: 0,
            phone: localStorage['phone']!== undefined?localStorage['phone']:'',
			TouMFlag: false
        }
    }
    componentDidMount(){
        setScrollTop();
        this.getUserInfo();
        if(localStorage['uesrInfo'] !== undefined){
        	let uesrInfo = JSON.parse( localStorage['uesrInfo']);
        	this.setState({
        		sHead: uesrInfo.img,
	            sNickname: uesrInfo.nickname,
	            iPoints: uesrInfo.gender
        	})
        }
    }
    outLogin(){
        if (this.state.phone.length>0){
            Modal.alert('', '确认要退出吗？', [
                { text: '取消', onPress: () => {}, style: 'default' },
                { text: '确认', onPress: () => {
//                      let sUrl=config.baseUrl+"/api/home/user/safeout?token="+config.token;
//                      request(sUrl, "post",{uid:this.props.state.user.uid}).then(res=>{
//                          if (res.code===200){
//                              this.props.dispatch(action.user.outLogin());
//                              this.props.dispatch(action.cart.clearCart());
//                              this.props.history.push(config.path+'login/index');
//                          }
//                      });
                    }
                }
            ]);
        }else{
            this.props.history.push('/login');
        }

    }
    getUserInfo(){
//      if (this.props.state.user.isLogin===true) {
//          let sUrl = config.baseUrl + "/api/user/myinfo/userinfo/uid/" + this.props.state.user.uid + "?token=" + config.token;
//          request(sUrl).then(res => {
//              if (res.code === 200) {
//                  this.setState({sHead: res.data.head!==''?res.data.head:this.state.sHead, sNickname: res.data.nickname, iPoints: res.data.points});
//              }
//          });
//      }
    }
    componentWillUnmount(){
        this.setState=(state,callback)=>{
            return;
        }
    }
    pushPage(val){
		if(this.state.TouMFlag)return
    	if(val == 'shezhi'){
    		this.props.history.push('/exit');
    	}else{
    		//this.props.history.push('/notfind');
			this.setState({
				TouMFlag: true
			})
			//分享
			const ua = window.navigator.userAgent.toLowerCase()
			// 判断微信
			if (ua.indexOf('micromessenger') >= 0){
				this.JianQuan();
			}
    	}
    }
	TouMClick(){
		this.setState({
			TouMFlag: false
		})
	}
	JianQuan() {
		//鉴定权限是否可用
		let data = {
			url: window.location.href
		}
		let that = this;
		request(config.baseUrl+'api/AM/AM03', "post", data).then(res=>{
			if(res.code == 0){
		    	that.zhiXing(res.data);
		    }
		});
	}
	zhiXing(json) {
		let data = json;
		data.jsApiList = [
			"updateAppMessageShareData",
			"updateTimelineShareData",
			'onMenuShareAppMessage',
			'onMenuShareTimeline',
		];
		data.openTagList = [
			"wx-open-launch-app"
		];
		data.debug = false;
		wx.config(data);
		this.fenxiang();
		this.OpApp();
	}
	fenxiang() {
		// 设置成功
		var share = {
			title: 'PTT养猪时效学院', // 分享标题
			desc: 'PTT养猪时效学院', // 分享描述
			link: 'http://ptt.zlgxt.cn/h5', // 分享链接
			imgUrl: '../../../assets/images/video/logo.png', // 分享图标
			success: function() {}
		}
		//分享给朋友
		wx.updateAppMessageShareData(share);
		wx.onMenuShareAppMessage(share);
		//分享给朋友圈
		wx.updateTimelineShareData(share);
		wx.onMenuShareTimeline(share);
	}
	OpApp() {
		this.openApp = document.querySelector('.openAppCent');
		this.openApp.innerHTML = `<wx-open-launch-app id="launch-btn2" appid="wx42bb27797e4040b2" extinfo="123456" >
			<template>
				<style>
					.btn { 
						width: 100%;
						padding: 10px 0;
						border-radius: 6px;
						border: none;
						background-color: #00CCA9;
						color: #fff;
						font-size: 100%;
						z-index: 1002;
					}
				</style>
				<button class="btn">更多内容请<br />进入App内查看</button>
			</template>
		</wx-open-launch-app>`;
		var btn = document.getElementById('launch-btn2');
		//console.log(btn)
		btn.addEventListener('launch', function (e) {
			//alert('success');
		});
		btn.addEventListener('error', function (e) {
			alert('未检测到App，跳转默认浏览器下载App？');
			window.location.href = "http://ptt.zlgxt.cn/h5/downloadAPP/";
		});
	}
    render(){
        return(
            <div>
                <div className={'user-info-wrap'}>
                	<div className={'set'} onClick={this.pushPage.bind(this)}>
                		<img src={require("../../../assets/images/video/message.png")} alt="图片" />
                	</div>
                </div>
                <div className={'user-info-Img'}>
                	<div className={'user-info-Img1'}>
	                	<div className={'head'}>
	                        <img src={this.state.sHead} alt={this.state.sNickname}/>
	                    </div>
	                    <div>
	                    	<div className={'nickname'}>
	                    		{this.state.sNickname}
	                    	</div>
	                    </div>
                	</div>
                    <div className={'points'}>
               	 		<span>享200+精彩课程</span>
               	 		<span>开通VIP</span>
               	 	</div>
                </div>
                <div style={{'marginBottom':'1.3rem'}}>
	                <div className={'user-info-row'}>
	                	<div className={'row-content row-content-num'} onClick={this.pushPage.bind(this)}>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			0
		                		</div>
		                		<div className={'info-list-title'}>学习时长(分钟)</div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			0
		                		</div>
		                		<div className={'info-list-title'}>学习课程数(个)</div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			0
		                		</div>
		                		<div className={'info-list-title'}>考试(场)</div>
		                	</div>
	                	</div>
	                </div>
	                <div className={'user-info-row'} onClick={this.pushPage.bind(this)}>
	                	<div className={'row-title'}>我的学习</div>
	                	<div className={'row-content'}>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx1.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>数据</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx2.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>勋章</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx3.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>证书</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx4.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>学分</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx5.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>笔记</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx6.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>排行榜</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx7.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>历史</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx8.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>下载</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx9.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>收藏</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/myx10.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>提问</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
	                	</div>
	                </div>
	               	<div className={'user-info-row'}>
	                	<div className={'row-title'}>我的学习</div>
	                	<div className={'row-content'}>
		                	<div className={'user-info-list'} onClick={this.pushPage.bind(this)}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/cy1.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>已购</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'} onClick={this.pushPage.bind(this)}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/cy2.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>卡券</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'} onClick={this.pushPage.bind(this)}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/cy3.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>账户</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'} onClick={this.pushPage.bind(this)}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/cy4.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>订单</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
		                	<div className={'user-info-list'} onClick={this.pushPage.bind(this, 'shezhi')}>
		                		<div className={'info-list-img'}>
		                			<img src={require("../../../assets/images/video/cy5.png")} alt="图片" />
		                		</div>
		                		<div className={'info-list-title'}>设置</div>
		                		<div className={'info-list-numb'}></div>
		                	</div>
	                	</div>
	                </div>
                </div>
				<div className={this.state.TouMFlag?'openApp':'openApp hide'}>
					<span className={"openAppClose"} onClick={this.TouMClick.bind(this)}>
						<img src={require('../../../assets/images/common/x.png')} />
					</span>
					<div className={'openAppCent'}></div>
				</div>
        	</div>
        );
    }
}